import { render, staticRenderFns } from "./message-rich-text.vue?vue&type=template&id=258fa59e"
import script from "./message-rich-text.vue?vue&type=script&lang=ts"
export * from "./message-rich-text.vue?vue&type=script&lang=ts"
import style0 from "./message-rich-text.vue?vue&type=style&index=0&id=258fa59e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports